import { render, staticRenderFns } from "./NewPhotos.vue?vue&type=template&id=63706f00"
import script from "./NewPhotos.vue?vue&type=script&lang=js"
export * from "./NewPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports